import { useMinutosParaVencer } from './useSesion';
import type { Sesion } from './almacen';

/** Con menos que esto por delante, se avisa. */
const MINUTOS_DE_AVISO = 5;

/**
 * Banda que avisa que el token está por vencer.
 *
 * # POR QUÉ AVISA Y NO CIERRA
 *
 * Sería fácil poner un `setTimeout` a la hora de `venceEn` y cerrar la sesión
 * solo. **No se hace, a propósito.** El reloj del navegador no es el del
 * servidor, y el único que sabe de verdad si el token sirve es el backend, que
 * lo dice con un `401`. Cerrar por las nuestras un minuto antes tiraría un
 * formulario a medio llenar sin que hiciera falta.
 *
 * Entonces: el `venceEn` que devolvió el login se usa para **avisar** —para que
 * nadie empiece a cargar una factura larga con dos minutos de token— y el
 * cierre lo decide el backend. Y `venceEn` viene justamente para esto: para no
 * tener que **decodificar el JWT en el cliente**, que sería leer como verdad un
 * dato cuya firma el front no puede verificar.
 */
export function AvisoDeVencimiento({ sesion }: { sesion: Sesion }) {
  const minutos = useMinutosParaVencer(sesion);

  if (minutos === null || minutos > MINUTOS_DE_AVISO) {
    return null;
  }
  return (
    <p role="status" className="aviso">
      {minutos > 0
        ? `Tu sesión vence en ${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}. Guardá lo que estés haciendo.`
        : 'Tu sesión está por terminar. Guardá lo que estés haciendo.'}
    </p>
  );
}
